import { createFileRoute } from '@tanstack/react-router';
import OrdinaryGraphOnline from '../../../components/Graphs/OrdinaryGraph';
import { getNameFromUrl } from '../../../components/Graphs/GraphService';

export const Route = createFileRoute('/_authenticated/graphs/$name/$vehicleId')({
  beforeLoad: ({ context }) => {
    // requirePermission(PERMISSION_RIDES, ['read']);
    return {
      ...context,
      // documentTitle: {
      //   // main: getNameFromUrl(`/${name}`),
      //   // suffix: 'menu.overviewTours',
      // },
      isMenuDisabled: true,
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: GenericGraphRoute,
});

function GenericGraphRoute() {
  const { vehicleId, name } = Route.useParams();

  return (
    <OrdinaryGraphOnline vehicleId={Number(vehicleId)} name={getNameFromUrl(`/${name}`)} isPage />
  );
}
